import { UserRoleDTO } from "./UserRoleDTO";

export class ActivateUsersRequestDTO {
    userAfms:string[];
    loggedInUser:UserRoleDTO;
}